import { Row, Col, Spacer } from '@amzn/stencil-react-components/layout';
import { H3, Text } from '@amzn/stencil-react-components/text';
import React from 'react';
import Img1 from '../../img/WelcomeSlides/slide2-img1.png';

const Slide2 = () => {
  return (
    <Col alignItems="center">
      <H3>Happy customization</H3>
      <Spacer height={12} />
      <Text>Wondering how to customize nudges using nudge engine ?</Text>
      <Text>1. Identify your recipients by mapping employee lifecycle touchpoints</Text>
      <Text>2. Create interactive and personalized campaigns at scale</Text>
      <Text>3. Release nudges directly or by automated scheduling</Text>
      <Text>4. Track nudge engagement and make adjustments</Text>

      <Row flex="1" alignItems="center">
        <Col>
          <img async src={Img1} width={'100%'} />
        </Col>
      </Row>
    </Col>
  );
};

export default Slide2;
